<template>
    <section class="itb-hero-cards">
        <div v-if="appParams && appParams.staticTranslations" class="container">
            <div
                v-for="card in cards"
                v-if="card.type == 'left' || card.type == 'right'"
                class="itb-hero-card row d-flex align-content-center mx-0 itb-lazy-loading-bg"
                :class="card.hero_classes ? card.hero_classes : ''"
                v-lazy:background-image="
                    card.bg_image && !isResponsive
                        ? card.bg_image
                        : '/images/articles/blank-bg.webp'
                "
                style="background-size: cover"
                :style="card.hero_styles ? card.hero_styles : ''"
                :key="card.id"
            >
                <div
                    v-if="isResponsive"
                    class="itb-hero-responsive-image"
                    v-lazy:background-image="
                        card.bg_image ? card.bg_image : null
                    "
                ></div>
                <div
                    v-if="card.hero_card_prepend_id"
                    :id="card.hero_card_prepend_id"
                    v-lazy:background-image="card.hero_card_prepend_lazy_bg"
                ></div>

                <div
                    v-if="card.hero_card_prepend_id_2"
                    :id="card.hero_card_prepend_id_2"
                    v-lazy:background-image="card.hero_card_prepend_lazy_bg_2"
                    :class="adjustmentClasses(card.hero_card_prepend_id_2)"
                ></div>

                <div class="col-12" v-if="card.title || card.texts">
                    <div
                        class="itb-card"
                        :class="
                            (card.type == 'right' ? 'ml-auto right' : '') +
                            (card.card_classes ? ' ' + card.card_classes : '')
                        "
                        :style="card.card_styles ? card.card_styles : ''"
                    >
                        <h2 v-if="card.title" v-html="card.title"></h2>
                        <div v-html="card.texts"></div>

                        <button
                            v-if="
                                card.button_type == 'contact-form' ||
                                card.button_type == 'scroll'
                            "
                            class="btn itb-btn-icon"
                            :class="
                                card.type == 'right'
                                    ? 'btn-primary'
                                    : 'btn-secondary'
                            "
                            @click="
                                scrollToElement(
                                    card.scroll_to
                                        ? card.scroll_to
                                        : 'itb-contact-form'
                                )
                            "
                        >
                            {{
                                appParams.staticTranslations[
                                    card.link_text
                                        ? card.link_text
                                        : "realizations.i_want_proposal_free"
                                ]
                            }}
                            <img
                                src="/images/icons/4soft_icon_angle-down.svg"
                                :alt="
                                    appParams.staticTranslations[
                                        'realizations.i_want_proposal_free'
                                    ]
                                "
                                class="itb-icon itb-angle-down-icon"
                            />
                        </button>
                        <router-link
                            v-else-if="card.button_type == 'link'"
                            :to="card.link"
                            class="btn itb-btn-icon"
                            :class="
                                card.type == 'right'
                                    ? 'btn-primary'
                                    : 'btn-secondary'
                            "
                        >
                            {{ appParams.staticTranslations[card.link_text] }}
                            <img
                                src="/images/icons/4soft_icon_angle-right.svg"
                                :alt="
                                    appParams.staticTranslations[
                                        'general.button'
                                    ] +
                                    ' ' +
                                    appParams.staticTranslations[
                                        'realizations.show_realizations'
                                    ]
                                "
                                class="itb-icon itb-angle-right-icon"
                            />
                        </router-link>
                        <a
                            v-else-if="card.link"
                            class="btn itb-btn-icon"
                            :class="
                                card.type == 'right'
                                    ? 'btn-primary'
                                    : 'btn-secondary'
                            "
                            :href="appParams.staticTranslations[card.link]"
                            target="_blank"
                        >
                            {{ appParams.staticTranslations[card.link_text] }}
                            <img
                                src="/images/icons/4soft_icon_angle-right.svg"
                                :alt="
                                    appParams.staticTranslations[
                                        'constants.' + card.link_text
                                    ]
                                "
                                class="itb-icon itb-angle-right-icon"
                            />
                        </a>

                        <button
                            v-if="
                                card.button_type_2 == 'contact-form' ||
                                card.button_type_2 == 'scroll'
                            "
                            class="btn itb-btn-icon ml-4"
                            :class="
                                card.type == 'right'
                                    ? 'btn-primary'
                                    : 'btn-secondary'
                            "
                            @click="
                                scrollToElement(
                                    card.scroll_to_2
                                        ? card.scroll_to_2
                                        : 'itb-contact-form'
                                )
                            "
                        >
                            {{
                                appParams.staticTranslations[
                                    card.link_text_2
                                        ? card.link_text_2
                                        : "realizations.i_want_proposal_free"
                                ]
                            }}
                            <img
                                src="/images/icons/4soft_icon_angle-down.svg"
                                :alt="
                                    appParams.staticTranslations[
                                        'realizations.i_want_proposal_free'
                                    ]
                                "
                                class="itb-icon itb-angle-down-icon"
                            />
                        </button>
                        <router-link
                            v-else-if="card.button_type_2 == 'link'"
                            :to="card.link_2"
                            class="btn itb-btn-icon ml-4"
                            :class="
                                card.type == 'right'
                                    ? 'btn-primary'
                                    : 'btn-secondary'
                            "
                        >
                            {{ appParams.staticTranslations[card.link_text_2] }}
                            <img
                                src="/images/icons/4soft_icon_angle-right.svg"
                                :alt="
                                    appParams.staticTranslations[
                                        'general.button'
                                    ] +
                                    ' ' +
                                    appParams.staticTranslations[
                                        'realizations.show_realizations'
                                    ]
                                "
                                class="itb-icon itb-angle-right-icon"
                            />
                        </router-link>
                        <a
                            v-else-if="card.link_2"
                            class="btn itb-btn-icon ml-4"
                            :class="
                                card.type == 'right'
                                    ? 'btn-primary'
                                    : 'btn-secondary'
                            "
                            :href="appParams.staticTranslations[card.link_2]"
                            target="_blank"
                        >
                            {{ appParams.staticTranslations[card.link_text_2] }}
                            <img
                                src="/images/icons/4soft_icon_angle-right.svg"
                                :alt="
                                    appParams.staticTranslations[
                                        'constants.' + card.link_text_2
                                    ]
                                "
                                class="itb-icon itb-angle-right-icon"
                            />
                        </a>

                        <button
                            v-if="
                                card.button_type_3 == 'contact-form' ||
                                card.button_type_3 == 'scroll'
                            "
                            class="btn itb-btn-icon"
                            :class="
                                card.type == 'right'
                                    ? 'btn-primary'
                                    : 'btn-secondary'
                            "
                            @click="
                                scrollToElement(
                                    card.scroll_to
                                        ? card.scroll_to
                                        : 'itb-contact-form'
                                )
                            "
                        >
                            <img
                                src="/images/icons/4soft_icon_angle-right.svg"
                                alt="4soft_icon_angle-right"
                                class="itb-icon itb-angle-right-icon"
                            />
                            <span class="mx-3">
                                {{
                                    appParams.staticTranslations[
                                        card.link_text
                                            ? card.link_text
                                            : "realizations.i_want_proposal_free"
                                    ]
                                }}
                            </span>
                            <img
                                src="/images/icons/4soft_icon_angle-left.svg"
                                alt="4soft_icon_angle-left"
                                class="itb-icon itb-angle-left-icon"
                            />
                        </button>
                    </div>
                </div>
            </div>
            <div
                v-else-if="card.type == 'grey'"
                class="itb-hero-card itb-grey row mx-0"
            >
                <div class="col-12">
                    <h2
                        v-html="card.title"
                        :class="!card.subtitle ? 'mb-4' : 0"
                    ></h2>
                    <h3 v-if="card.subtitle" v-html="card.subtitle"></h3>
                    <div class="row">
                        <div
                            class="col-12 col-md-6 itb-left"
                            v-html="card.texts_a"
                        ></div>
                        <div
                            class="col-12 col-md-6 itb-right"
                            v-html="card.texts_b"
                        ></div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { mapGetters } from "vuex";
export default {
    name: "HeroCards",
    props: {
        cards: Array,
    },
    data() {
        return {
            isResponsive: false,
        };
    },

    computed: {
        ...mapGetters({
            appParams: "getAppParams",
        }),
    },

    created() {
        this.onResize();
        window.addEventListener("resize", this.onResize);
    },

    beforeDestroy() {
        window.removeEventListener("resize", this.onResize);
    },

    methods: {
        scrollToElement(elementId) {
            this.$parent.scrollToElement(elementId);
        },

        onResize() {
            if (window.innerWidth < 992) {
                this.isResponsive = true;
            } else {
                this.isResponsive = false;
            }
        },

        adjustmentClasses(elementId) {
            var classes = {};
            if (
                this.$store.state.domainLanguage == "fr" &&
                elementId == "itb-2D-products-glue-label"
            ) {
                classes["itb-2D-products-glue-label-adjusted"] = true;
            }
            return classes;
        },
    },
};
</script>
